import React from 'react';
import Typography from 'apollo-react/components/Typography';

import BestDayTimePage from '../BestDayTime';
import MessageCappingConfigurationPage from '../MessageCappingConfigurationPage';

export const MainComponent = props => (
  <React.Fragment>
    <MessageCappingConfigurationPage {...props} />
    {props.activityType &&
      props.activityType.length > 1 && (
        <Typography
          variant="caption"
          display="block"
          style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}
        >
          {'AND'}
        </Typography>
      )}
    <BestDayTimePage {...props} />
  </React.Fragment>
);

MainComponent.displayName = 'MainComponent';

export default MainComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/Main/MainComponent.js